export default {"src":"/uk/_next/static/media/icon-show.12d10346.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};